var s80Theme = {
    label: {
        color: '#eee917',
        disabledColor: '#eee917',
        fontSize: '1em',
    },
    window: {
        border: "5px ridge #4F94CD",
        title: {
            background: '#4F94CD',
            color: 'white',
        },
        content: {
            background: 'rgb(43, 56, 86)',
        },
    },
    radio: {
        button: {
            height: '11px',
            width: '11px',
            checked: {
                background: '#FFC502',
            },
        },
    },
    comboBox: {
        color: '#eee917',
    },
    button: {
        color: '#eee917',
        textDecoration: 'underline',
    },
    textInput: {
        backgroundColor: '#12144C',
    },
    datagrid: {
        table: {
            backgroundColor: '#12144C',
        },
    },
    checkbox: {
        input: {
            margin: '1px',
            height: '18px',
            width: '18px',
            appearance: 'auto',
            background: 'white',
            checked: {
                appearance: 'none',
                background: '#FFC502',
            },
        },
    },
};
export default s80Theme;
//# sourceMappingURL=s80-theme.js.map